/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveClientTeamMemberRequest
 */
export interface RemoveClientTeamMemberRequest {
    /**
     * Keycloak user UUID of the member to remove.
     */
    userUUID: string;
}

/**
 * Check if a given object implements the RemoveClientTeamMemberRequest interface.
 */
export function instanceOfRemoveClientTeamMemberRequest(value: object): value is RemoveClientTeamMemberRequest {
    if (!('userUUID' in value) || value['userUUID'] === undefined) return false;
    return true;
}

export function RemoveClientTeamMemberRequestFromJSON(json: any): RemoveClientTeamMemberRequest {
    return RemoveClientTeamMemberRequestFromJSONTyped(json, false);
}

export function RemoveClientTeamMemberRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveClientTeamMemberRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userUUID': json['userUUID'],
    };
}

export function RemoveClientTeamMemberRequestToJSON(json: any): RemoveClientTeamMemberRequest {
    return RemoveClientTeamMemberRequestToJSONTyped(json, false);
}

export function RemoveClientTeamMemberRequestToJSONTyped(value?: RemoveClientTeamMemberRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userUUID': value['userUUID'],
    };
}

